import React, {useState, useContext, useEffect, useRef } from 'react';
import { IonCard, IonInput, IonText, IonLabel, IonSlides, IonSlide, IonImg, IonModal, IonGrid, IonRow, IonCol, IonButton, IonCardContent, IonContent, IonHeader, IonFooter, IonToolbar } from '@ionic/react';

//import { Bluefin_Hotel_context } from '../../../storeState/bluefin_hotel_context';
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import '../../css/layout.css';

import { TakePhoto, photos } from '../../zInternal_Features/merchant/components/TakePhoto';

import { Registration_GeoLocation} from './Registration_GeoLocation'

import { MerchantLoginCredentials } from './LoginCredentials_merchant';
import {RegisterIndividualModal} from './Register_Individual_Modal';

export function RequestEstimateModal (props) {

    //let authenticatedMerchent_context = useContext(Auth_MerchantID_context);
    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);
    const [acctID, setAcctID ] = useState(authMerchant_objects.acctID);
    const [schema, setSchemaName] = useState(authMerchant_objects.schema);
    let [authenticated, setIsAuthenticated] = useState(authMerchant_objects.authenticated);

    let [sessionID, setSessionID ] = useState(authMerchant_objects.sessionID);

    let [takePhotoStatus, setTakePhotoStatus] = useState(null);
    let [selectedFile, setSelectedFile] = useState(null);

    //let [checkInAttachment, setCheckInAttachment ] = useState(null);
    let [attachment_ID, setAttachment_ID ] = useState(null);

    let [estimateLatitude, setEstimateLatitude] = useState(null);
    let [estimateLongitude, setEstimateLongitude] = useState(null);


    let [merchantLoginModal, setMerchantLoginModal] = useState(false);
    let [registerModal_individial, setRegisterModal_individual] = useState(false);

    let [username, setUsername] = useState('');
    let [password, setPassword] = useState('');

    let [saveEvent, setSaveEvent] = useState([]);
    let [disablePayButton, setDisablePayButton] = useState(false);

    let [mobileNumber, setMobileNumber] = useState('');
    let [errorMessage, setErrorMessage] = useState('');

    let enterMemberPaymentAmountRef = useRef();
    let enterFirstNameRef = useRef();
    let enterLastNameRef = useRef();
    let enterMobileNumberRef = useRef();
    let enterPasswordRef = useRef();
    let enterEmailRef = useRef();
    let enterEstimateDescriptionRef = useRef();

    let enterID_numberRef = useRef('00000');
    
    let enterCC_numberRef = useRef();
    let enterCC_expDateRef = useRef();
    let enterCC_cvvNumberRef = useRef();
    let enterCC_addressRef = useRef();
    let enterCC_cityRef= useRef();
    let enterCC_stateRef = useRef();
    let enterCC_zipRef = useRef();
    let enterCC_nonMember_amountRef = useRef();

    let enterMM_displayRef = useRef();
    let selectMobileMoneyProviderRef = useRef();
    let enterMM_phoneNumberRef = useRef();
    let enterMM_nonMember_amountRef = useRef();


    let enterChecking_displayRef = useRef();
    let enterChecking_bankNameRef = useRef();
    let enterChecking_accountNumberRef = useRef();
    let enterChecking_routingNumberRef = useRef();
    let enterChecking_nonMember_amountRef = useRef();

    let enterCash_displayRef = useRef();
    let enterCash_amountRef = useRef();



function selectedFileHandler(event)
{

    setSelectedFile(event);

}

function handleFileChange(event) {


    const file = event.target.files ? event.target.files[0] : null;
    setSelectedFile(file);
}


function retrieveCurrentGeolocation(event) 
{
    //alert("in get current registration coordinates");
    // alert(event);
    // alert(event[0]);
    // alert(event[1]);

    setEstimateLatitude(event[0]);
    setEstimateLongitude(event[1]);
}

    
function handleEnterAttachement() {  


    fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
    .then(res => res.blob())
    .then(data => {

        //alert(JSON.stringify(data));

        const blobUrl = URL.createObjectURL(data);

        let noImageFile = new File([data], blobUrl, {
            enctype: 'multipart/form-data',
            type: 'image/jpeg',
            name: 'xImageFile',
            accept: "image/*",
        });
        
        setAttachment_ID(noImageFile);

        //alert("No Attachment Option checked");

    })
}


    function confirmEstimate(accountID, schemaName)
    {
    
        // alert('In Confirm Estimate');
        // alert(schema);
        // alert(props.data.companyId);
        // alert(props.data.companySchema);

    
            let formData = new FormData();
            formData.append('Tracker', '74706_add_estimate_public');
            formData.append('user', accountID);
            formData.append('schema', schemaName);
            formData.append('xCompanyID_public', props.data.companyID);
            formData.append('merchantSchema', props.data.companySchema);
            formData.append('xCustomerFirstName', enterFirstNameRef.current.value.replace(/\s+/g, '_'));
            formData.append('xCustomerLastName', enterLastNameRef.current.value.replace(/\s+/g, '_'));
            formData.append('xCustomerMobileNumber', mobileNumber.replace(/\s+/g, ''));
            formData.append('xEnterNewPassword' , password)
            formData.append('xEstimateDescription', enterEstimateDescriptionRef.current.value.replace(/\s+/g, ''));
            formData.append('xCustomerLatitude', estimateLatitude);
            formData.append('xCustomerLongitude', estimateLongitude);
            formData.append('sessionID', sessionID);    
            formData.append('xPic1', selectedFile);
    
    
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                //credentials: 'include',
                file: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            
            alert('In Confirm Estimate 2');
            alert(baseURL);
    
            let newBaseURL = 'https://ghanaverified.com';
            if(baseURL == 'https://bluefinhoteltest.com/' || baseURL == 'https://bluefinhoteltest.com/overviewTab')
            {
                newBaseURL = 'https://ghanaverifiedtest.com'
            }
    
    
            fetch(baseURL+'ghanaverified_proService/', requestOptions)
            //fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                alert('res');
        
            })
    
            props.closeModal(false);

    
    }

function confirmEstimateHandler(e)
{
    e.preventDefault();

    confirmEstimate();

    //confirmGuestBooking(e);
}

function handleMobileNumberChange(e) {

    const input = e.detail.value || '';
    if (!input.startsWith('0')) {
        setErrorMessage('Mobile number must start with 0.');
    } else {
        setErrorMessage('');
    }
    setMobileNumber(input);
    //enterMobileNumberRef.current = input;
};

function handleRequestEstimate(e)
{

    // alert('In handleRequestEstimate');
    // alert(e);
    // alert(acctID);
    e.preventDefault();

    if(acctID == null)
    {
        //authMerchant_objects.changeAccountID('register_request');
        //setSaveEvent(event);
        setRegisterModal_individual(true);
    }
    if(acctID != null)
    {
        confirmEstimate(acctID, schema);
    }
}


function handleCloseModal(event)
{
    // alert("AFTER REGISTER")
    // alert(event)
    // alert(event[0])
    // alert(event[1])

    setUsername(event[0]);
    setPassword(event[1]);
    setRegisterModal_individual(false);
    setMerchantLoginModal(true);
}

function handleCloseModal_merchantLogin(event)
{
    //alert('handleCloseModal_merchantLogin');
    //alert(event);

    if(event[0] == 'REGISRATION_LOGIN_COMPLETED')
    {
        setIsAuthenticated(event[1]);
        setAcctID(event[2]);
        setSchemaName(event[3]);
        confirmEstimate(saveEvent, event[1], event[2], event[3]);
    }
    else
    {
        alert('LOGIN FAILED, PLEASE TRY AGAIN.');
        //merchantLoginModal(false);
    }
    
}



function closeModalHandler() {

    props.closeModal(false);
}

useEffect(() => {
    //alert (checkInAttachment_ID);

    // alert('In  Estimate useEffect');
    // alert(schema);
    // alert(props.data.companyID);
    // alert(props.data.companySchema);

    handleEnterAttachement();

}, [])

//alert('Inside Reservation Enter booking');

return (
    <React.Fragment>
        {props.openModal == true ?
            (
        <IonModal isOpen={ props.openModal }>
            <form onSubmit={handleRequestEstimate}>
            <IonHeader className='grid_header' style={{ color: "black" }} fullscreen={true}>
                <IonToolbar>
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <h3>REQUEST ESTIMATE</h3>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonToolbar>
            </IonHeader>
                
            <IonContent className='grid_content'>

                <IonGrid >
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>First Name: </IonLabel>
                            </IonCol>
                            <IonCol className='ionCol_inputContent' size='6'>
                                <IonInput placeholder='Enter' ref={enterFirstNameRef } required></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel>Last Name: </IonLabel>
                            </IonCol>
                            <IonCol className='ionCol_inputContent' size='6'>
                                <IonInput placeholder='Enter' ref={enterLastNameRef } required></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            {/*<IonCol size='6'>
                                <IonLabel>Mobile Number: </IonLabel>
                            </IonCol>
                            <IonCol className='ionCol_inputContent' size='6'>
                                <IonInput placeholder='Enter' ref={enterMobileNumberRef} required></IonInput>
                            </IonCol>*/}
                            <IonCol size="6">
                                <label htmlFor="searchSupplierName">Mobile Number:</label>
                            </IonCol>
                            <IonCol className='ionCol_inputContent' size="6">
                                <IonInput
                                    id="searchSupplierName"
                                    placeholder="Enter mobile number"
                                    type="tel"
                                    value={mobileNumber}
                                    onIonChange={(e) => handleMobileNumberChange(e)}
                                    required/>
                                {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel>Request Description: </IonLabel>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className='ionCol_inputContent' size='12'>
                                <textarea cols="40" rows="10" placeholder='Request Description' ref={ enterEstimateDescriptionRef } required></textarea>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='12'>                            
                                <IonButton  onClick={() => setTakePhotoStatus(true)}> Take Photo</IonButton>
                                {takePhotoStatus == true && <TakePhoto onSelectedFile={selectedFileHandler}></TakePhoto>}
                            </IonCol>
                            <IonCol size='12'>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                </IonGrid>

            </IonContent>

            <IonFooter className='grid_footer'>
                <IonButton type='submit' className='grid_checkInFooter_left'> Confirm Request </IonButton>
                {/*<IonButton className='grid_checkInFooter_left' onClick={() => confirmGuestBookingHandler()}> Confirm Booking </IonButton>*/}
                <IonButton onClick={() => closeModalHandler()} className='grid_checkInFooter_right'> Cancel </IonButton>
            </IonFooter>
            </form>

            <Registration_GeoLocation gps_location={retrieveCurrentGeolocation} ></Registration_GeoLocation>


            {registerModal_individial == true && <RegisterIndividualModal  openModal={registerModal_individial} closeModal={(event) => handleCloseModal(event)} payCloseModal={(event) => setRegisterModal_individual(event)} data={{
                                                        source: 'online_pay_register', 
                                                        register_firstName: enterFirstNameRef.current.value.replace(/\s+/g, '_'),
                                                        register_lastName: enterLastNameRef.current.value.replace(/\s+/g, '_'),
                                                        register_phoneNumber: mobileNumber.replace(/\s+/g, '_'),
                                                        }}></RegisterIndividualModal>}
            {merchantLoginModal == true && <MerchantLoginCredentials openModal={ merchantLoginModal } closeModal={(event) => handleCloseModal_merchantLogin(event)} payCloseModal={(event) => setMerchantLoginModal(event)} data={{
                                                    source: 'online_pay_register_completed',
                                                    username: username, 
                                                    password: password,
                                                    }}></MerchantLoginCredentials>}

            </IonModal>
            ) : null}

    </React.Fragment>)
}